// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, uiActions} from '@/store'

type Props = {
  activePortfolioId?: number,
  setupEditPortfolioForm: (number) => void,
  showEditModal: (props: ModalProps) => void,
  l: Language,
}

const renderButton = (props: Object) =>
  <button id='edit_portfolio'
    className="btn btn-warning"
    onClick={() => {
      props.setupEditPortfolioForm(props.activePortfolioId)
      props.showEditModal({
        title: 'Edit portfolio',
        onConfirm: props.updateActivePortfolio,
      })
    }}
  >
    {props.l('Edit portfolio')}
  </button>

const RawEditPortfolioButton = (props: Props) =>
  props.activePortfolioId ? renderButton(props) : null

const mapStateToProps = (state) => ({
  activePortfolioId: appSelectors.getActivePortfolioId(state),
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawEditPortfolioButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/edit-portfolio-button.js